'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHocWithRef = require('react-hoc-with-ref');

var _reactHocWithRef2 = _interopRequireDefault(_reactHocWithRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_createWithRef) {
    (0, _inherits3.default)(WithValidatorRule, _createWithRef);

    function WithValidatorRule() {
      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, WithValidatorRule);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _createWithRef.call.apply(_createWithRef, [this].concat(args))), _this), _this.setValidatorRule = function (validationRule) {
        _this.userValidatorRule = validationRule;
      }, _this.validationRule = function () {
        if (_this.userValidatorRule) {
          _this.userValidatorRule();
        }
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    WithValidatorRule.prototype.componentDidMount = function componentDidMount() {
      this.callValidatorMethod('addRules', this.validationRule);
    };

    WithValidatorRule.prototype.componentWillUnmount = function componentWillUnmount() {
      this.callValidatorMethod('removeRules', this.validationRule);
    };

    WithValidatorRule.prototype.callValidatorMethod = function callValidatorMethod(method) {
      var validator = this.props.validator;

      if (validator) {
        var _validator$method;

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        (_validator$method = validator[method]).call.apply(_validator$method, [validator].concat(args));
      }
    };

    WithValidatorRule.prototype.render = function render() {
      return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, this.getRefProps(), {
        setValidatorRule: this.setValidatorRule
      }));
    };

    return WithValidatorRule;
  }((0, _reactHocWithRef2.default)(WrappedComponent)), _class.propTypes = {
    validator: _propTypes2.default.object
  }, _temp2;
};
//# sourceMappingURL=withValidatorRule.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-vld/lib/decorators/withValidatorRule.js
// module id = 1254
// module chunks = 0